  <template>
<div>
  <center>
  <div class="overallContainer">
<!-- Start the code for this screen here -->
  <div class="backgroundLayer">
    <div>
    <div class="detaileddesc">
      <br>
      <br>
    <span class="contactushead">New User Request</span>
    <br>
    <br>
    <span class="secondheading">If you are a new Employee at Luxury Lease Partners .</span>
<br>
<span class="secondheading thirdheading" >Please request for an account.</span>
</div>
<br><br><br>

<div class="sidebyside" style="border-color: rgb(204, 204, 204);line-height: 11.0pt; width: calc(50% - 4px); "><span class="label">First Name</span> </div>
<div class=" sidebyside" style="border-color: rgb(204, 204, 204);line-height: 11.0pt; width: calc(50% - 4px);"> <span class="label">Last Name</span></div>

<div class="backgroundLayer sidebyside" style="line-height: 11.0pt; width: calc(50% - 4px); "> <input class="label nameinput" type="text" value="" maxlength="100"  placeholder="First Name"></div>
<div class="backgroundLayer sidebyside" style="border-color: rgb(204, 204, 204);line-height: 11.0pt; width: calc(50% - 4px); "> <input class="label nameinput" type="text" value="" maxlength="100" placeholder="Last Name"></div>
<br>
<br><br>

<span class="label">E-Mail</span>

<div class="backgroundLayer" style="border-color: rgb(204, 204, 204);line-height: 11.0pt; width: calc(100% - 2px); "> <input class="label nameinput" type="text" value="" maxlength="100" placeholder="example@domain.com"> </div>

<br>
<br>
<div style="width:100%"><center><input type="submit" class="btnSubmit" value="Submit" id="send"><br><br>
<div class="backlink">

  <router-link to="/" tag="a" >Back</router-link>
</div></center></div>

<br>

    </div>
    </div> </div></center>
  <!-- End of the code for this screen here -->
   <bottom-footer></bottom-footer>
  </div>
</template>
<script>
import TopHeader from '@/components/TopHeader.vue'
import BottomFooter from '@/components/BottomFooter.vue'
import MainMenu from '@/components/Menu.vue'
export default {
  components: { MainMenu,
    TopHeader,
    BottomFooter
  }
}
</script>
<style scoped>
.contactushead{
      width: 100%;
    height: 100%;
        overflow: hidden;
  color: #000000;
      vertical-align: top;
    text-decoration: underline;
    font-size: 16.0pt;
    font-weight: 700;
}

.backgroundLayer{
  text-align: left;
 height: calc(100% + -2px);
 padding-left: 1%;
 padding-right: 1%;
    width: calc(100% + -2px);
    background-color: #FFFFFF;
    background-image: none;
    border-top-width: 1px;
    border-top-style: solid;
    border-top-color: #CCCCCC;
    border-right-width: 1px;
    border-right-style: solid;
    border-right-color: #CCCCCC;
    border-bottom-width: 1px;
    border-bottom-style: solid;
    border-bottom-color: #CCCCCC;
    border-left-width: 1px;
    border-left-style: solid;
    border-left-color: #CCCCCC;
    border-radius: 15px 15px 15px 15px;
    box-shadow: none;
}
.secondheading{
      color: #000000;
    text-align: left;
    text-decoration: none;

    font-size: 12.0pt;

    font-weight: 400;
    line-height: 0px;
}
.thirdheading{
  font-size: 11.0pt;
}
.detaileddesc{
text-align: center;
font-family: 'Arial',Arial;
  font-style: normal;
}
.label{
  color: #333333;
    text-align: left;
    text-decoration: none;
    font-family: 'Arial',Arial;
    font-size: 11.0pt;
    font-style: normal;
    font-weight: 400;
    line-height: 0px;
}
.nameinput{
      width: inherit;
      height: inherit;
          vertical-align: inherit;
          border: 0px;
}
.sidebyside {
    float:left;

}
input:focus,
textarea:focus
 {
    outline: none;
}
.btnSubmit{
    height:40px;width:140px;
}
.overallContainer{
  width: 30%;
}
</style>
